import { THEME_LABEL, ThemeChoice, useTheme } from '../lib/theme';
import { Icon } from './ui';

const OPTIONS: { id: ThemeChoice; icon: 'moon' | 'sun' | 'monitor' }[] = [
  { id: 'dark', icon: 'moon' },
  { id: 'light', icon: 'sun' },
  { id: 'system', icon: 'monitor' },
];

/** Dark / Light / Match system, as one segmented control. */
export function ThemePicker({ compact = false }: { compact?: boolean }) {
  const choice = useTheme((s) => s.choice);
  const choose = useTheme((s) => s.choose);
  return (
    <div role="radiogroup" aria-label="Theme" className="flex rounded-lg border border-line bg-abyss/50 p-0.5">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          role="radio"
          aria-checked={choice === o.id}
          title={THEME_LABEL[o.id]}
          onClick={() => choose(o.id)}
          className={`flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-xs transition ${
            choice === o.id ? 'bg-hull text-ink shadow-sm' : 'text-ink-3 hover:text-ink'
          }`}
        >
          <Icon name={o.icon} size={14} />
          {compact ? <span className="sr-only">{THEME_LABEL[o.id]}</span> : o.id === 'system' ? 'System' : THEME_LABEL[o.id]}
        </button>
      ))}
    </div>
  );
}
